/** @format */

import { Chain, Environment } from '@shared/data-access/interfaces';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import {
  IAthleteLoyaltyInfo,
  IReward,
  ITriplePointsRewards,
} from '@cart-checkout/data-access/interfaces';
/* istanbul ignore file */
import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AthleteDao {
  private readonly DEFAULT_HEADERS: Record<string, string>;
  private readonly HTTP_HEADERS: HttpHeaders;
  private readonly http: HttpClient = inject(HttpClient);
  private readonly chain: Chain = inject(Chain);
  private readonly environment: Environment = inject(Environment);

  constructor() {
    this.DEFAULT_HEADERS = {
      Accept: 'application/json;',
      'Content-Type': 'application/json',
      'Access-Control-Allow-Origin': '*',
      'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
      Pragma: 'no-cache',
      secret_key: this.environment.api.myaccount.secretKey,
      partner_key: this.environment.api.myaccount.partnerKey,
    };
    this.HTTP_HEADERS = new HttpHeaders(this.DEFAULT_HEADERS);
  }

  public static handleError(error: HttpErrorResponse | any) {
    return throwError(error);
  }

  /**
   * @description Get rewards for an athlete.
   */
  public getRewardsForAthlete$(activeOnly: boolean): Observable<IReward[]> {
    const url = `/myaccount/services/redirectingservice/athleteservice/v2/reward/${this.chain.chainIdentifierAbbr}?activeOnly=${activeOnly}`;
    const httpOptions = {
      headers: this.HTTP_HEADERS,
      withCredentials: true,
    };

    return this.http.get<IReward[]>(url, httpOptions);
  }

  /**
   *
   * @returns Triple points day data
   */
  public getTriplePointsRewardForAthlete$(): Observable<ITriplePointsRewards> {
    const url = `/myaccount/services/redirectingservice/athleteservice/v2/offers`;
    const httpOptions = {
      headers: this.HTTP_HEADERS,
      withCredentials: true,
    };

    return this.http.get<ITriplePointsRewards>(url, httpOptions);
  }

  public athleteHasAnAccountTiedToTheirEmail$(email: string): Observable<boolean> {
    const url =
      '/myaccount/services/redirectingservice/emailvalidationservice/v1/email/check-username';

    const httpOptions = {
      headers: this.HTTP_HEADERS,
      withCredentials: true,
    };

    return this.http.post<boolean>(url, { email }, httpOptions).pipe(
      map((response: any) => {
        return response.exists;
      }),
      catchError(AthleteDao.handleError),
    );
  }

  public getAthleteLoyaltyInfo$(): Observable<IAthleteLoyaltyInfo> {
    const url = `/myaccount/services/redirectingservice/athleteservice/v2/athlete/loyaltyinformation`;

    const httpOptions = {
      headers: this.HTTP_HEADERS,
      withCredentials: true,
    };

    return this.http.get<IAthleteLoyaltyInfo>(url, httpOptions);
  }

  public athleteEligibleForCreateAccountOnOrderConfirm(): Observable<any> {
    const url = `/api/v1/accounts`;

    const httpOptions = {
      headers: new HttpHeaders({
        Accept: 'application/json;',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
        Pragma: 'no-cache',
      }),
      withCredentials: true,
    };

    return this.http.get(url, httpOptions);
  }
}
